/**
 * 모바일 관리자 — 불러톡 대화창(/ma/chat/room)의 얇은 덧입힘.
 *
 * 대화창 본체는 이 모듈이 그리지 않는다 — 화면 전체를 공유 하네스($j.F.Chat +
 * mobile/pages/chat/chatRoom)가 잡는다. 여기서 하는 일은 둘 — **회원 프사를 눌러
 * 기사 상세 시트를 여는 것**과 헤더 뒤로 버튼(layouts/chat 의 data-back-url).
 *
 * PC(/adm/chat)는 같은 자리에서 $j.F.Admin.Util.memberPortal() 으로 기사관리 창을 띄운다
 * (F/Chat/Index 의 '.chat-avatar--user' 핸들러). 폰에는 그 전역이 없어 아무 일도
 * 일어나지 않았다 — 폰의 답은 새 창이 아니라 시트다.
 */
import { openDriverSheet } from './driverSheet';

export default class ChatRoom {
    initialize() {
        $j.F.Chat.init();   // 대화창 본체 (공유 하네스 — 값은 blade #chat-data)

        // 뒤로 — 히스토리를 쌓지 않는다 (CLAUDE.md 「페이지 이동」)
        $('.ma-ch-back').on('click', function () { location.replace(this.dataset.backUrl); });

        // 말풍선은 소켓·과거목록으로 계속 새로 그려지므로 위임으로 받는다.
        // .chat-avatar--user = 관리자 뷰에서 **방주인(회원)** 프사 (Draw.js). 상담원 프사엔 안 붙는다.
        $(document).on('click.machat', '.chat-avatar--user', (e) => {
            openDriverSheet(+$(e.currentTarget).data('mbno'));
        });
    }
}
